<script lang="ts">
	import { fade, fly } from "svelte/transition";
	import ToastItem from "./ToastItem.svelte";
	import { getToastStore } from "./toastStore";

	const store = getToastStore();
	function removeItem(e: { detail: string }) {
		store.remove(e.detail);
	}
</script>

<ul class="fixed bottom-0 right-4 p-4">
	{#each $store.items as item (item.id)}
		<li in:fly={{ x: 150 }} out:fade>
			<ToastItem {item} on:close={removeItem} />
		</li>
	{/each}
</ul>

<style>
	li + li {
		margin-top: 0.5rem;
	}
</style>
